"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OrderedMsgChain_1 = __importStar(require("./OrderedMsgChain"));

var OrderingUtil = /*#__PURE__*/function (_OrderedMsgChain_1$Ms) {
  _inherits(OrderingUtil, _OrderedMsgChain_1$Ms);

  var _super = _createSuper(OrderingUtil);

  function OrderingUtil(inOrderHandler, gapHandler, propagationTimeout, resendTimeout, maxGapRequests) {
    var _this;

    _classCallCheck(this, OrderingUtil);

    _this = _super.call(this);
    _this.inOrderHandler = inOrderHandler;
    _this.gapHandler = gapHandler;
    _this.propagationTimeout = propagationTimeout;
    _this.resendTimeout = resendTimeout;
    _this.maxGapRequests = maxGapRequests;
    _this.orderedChains = {};
    return _this;
  }

  _createClass(OrderingUtil, [{
    key: "add",
    value: function add(unorderedStreamMessage) {
      var chain = this.getChain(unorderedStreamMessage.getPublisherId(), unorderedStreamMessage.getMsgChainId());
      chain.add(unorderedStreamMessage);
    }
  }, {
    key: "getChain",
    value: function getChain(publisherId, msgChainId) {
      var _this2 = this;

      var key = publisherId + msgChainId;

      if (!this.orderedChains[key]) {
        var chain = new OrderedMsgChain_1.default(publisherId, msgChainId, this.inOrderHandler, this.gapHandler, this.propagationTimeout, this.resendTimeout, this.maxGapRequests);
        chain.on('error', function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _this2.emit.apply(_this2, ['error'].concat(args));
        });
        chain.on('skip', function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return _this2.emit.apply(_this2, ['skip'].concat(args));
        });
        chain.on('drain', function () {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return _this2.emit.apply(_this2, ['drain'].concat(args));
        });
        this.orderedChains[key] = chain;
      }

      return this.orderedChains[key];
    }
  }, {
    key: "markMessageExplicitly",
    value: function markMessageExplicitly(streamMessage) {
      var chain = this.getChain(streamMessage.getPublisherId(), streamMessage.getMsgChainId());
      chain.markMessageExplicitly(streamMessage);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return Object.values(this.orderedChains).every(function (chain) {
        return chain.isEmpty();
      });
    }
  }, {
    key: "clearGaps",
    value: function clearGaps() {
      Object.values(this.orderedChains).forEach(function (chain) {
        chain.clearGap();
      });
    }
  }, {
    key: "disable",
    value: function disable() {
      this.maxGapRequests = 0;
      Object.values(this.orderedChains).forEach(function (chain) {
        chain.disable();
      });
    }
  }]);

  return OrderingUtil;
}(OrderedMsgChain_1.MsgChainEmitter);

exports.default = OrderingUtil;